import moment from "moment";

import ApiService from "../../ApiService";
import AppConfig from "../../../config/AppConfig";
import Constants from "../../../config/Constants";
import * as Helper from "../../../utils/Helper";
// import { convertToAbsoluteUrl } from "../../../utils/Helper";
import SpeechRecognition from "../../../components/customModule/speechRecognition/SpeechRecognition";
// import OfflineStorageHelper from "../../../utils/OfflineStorageHelper";
// import { SpeechRecognizeTask } from "../../tasks/SpeechRecognizeTask";
// import { CompleteHomeworkTask } from "../../tasks/CompleteHomeworkApiCallTask";
// import { UpdateUnitResultApiCallTask } from "../../tasks/UpdateUnitResultApiCallTask";
// import { UnitUploadFileTask } from "../../tasks/UnitUploadFileTask";
import DebugLogger from "../../../utils/DebugLogger";
// import { BaseApiCallTask } from "../../tasks/BaseApiCallTask";
// import { StartHomeworkTask } from "../../tasks/StartHomeworkApiCallTask";
// import { RestartUnitTask } from "../../tasks/RestartUnitTask";

const generateFilePath = () => {
    const now = new moment().utc();
    const year = now.year();
    const month = (now.month() + 1).toString();
    const rootDir = Constants.LOCAL_FILE_STORAGE.TEMP_PATH;
    return `~${rootDir}tables/${year}/${month}/tables/UserHomeworkUnits/Files/`;
};

const generateFileName = () => {
    const now = new moment().utc();

    return `TEMP_FILE_${now.format("YYYYMMDDHHmmssSSS")}`;
};
//delay call back for offline
const delayCallback = callback => setTimeout(callback, 0);

const shouldUseOnlineService = () => {
    // return SessionHelper.isNetworkConnected() || !AppConfig.ENABLE_OFFLINE;
    return true;
};

const UnitService = {
    uploadFileImmediately(ownerId, ownerType, unitId, file, successCallback, failureCallback) {
        DebugLogger.log("@offline@uploadFileImmediately is called for unitId (" + unitId + ").");

        if (shouldUseOnlineService()) {
            let formData = new FormData();
            formData.append("table", "UserHomeworkUnits");
            formData.append("field", "Files");
            formData.append("clientType", 1);
            formData.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
            formData.append("clientBuild", AppConfig.APP_CLIENT_BUILD);
            formData.append("timeZone", Helper.getTimeZone());
            formData.append("fileData", file);

            ApiService.post("/common/file/upload", formData, successCallback, failureCallback);

            DebugLogger.log("@offline@uploadFileImmediately is executed for unitId (" + unitId + ").");
        } else {
            this.uploadFile(ownerId, ownerType, unitId, file, successCallback, failureCallback);
        }
    },

    uploadFile(ownerId, ownerType, unitId, file, successCallback, failureCallback) {
        DebugLogger.log("@offline@uploadFile is called for unitId (" + unitId + ").");

        // if (!AppConfig.ENABLE_OFFLINE) {
            let formData = new FormData();
            formData.append("table", "UserHomeworkUnits");
            formData.append("field", "Files");
            formData.append("clientType", 1);
            formData.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
            formData.append("clientBuild", AppConfig.APP_CLIENT_BUILD);
            formData.append("timeZone", Helper.getTimeZone());
            formData.append("fileData", file);

            ApiService.post("/common/file/upload", formData, successCallback, failureCallback);

            DebugLogger.log("@offline@uploadFile is executed for unitId (" + unitId + ").");
        // } else {
        //     // set uploadPath
        //     const path = generateFilePath();
        //     const fileName = generateFileName();
        //     let file_ext = "wav";
        //     if (file && file.name) {
        //         const rFileName = file.name;
        //         file_ext = rFileName.substr(rFileName.lastIndexOf(".") + 1, rFileName.length);
        //     }
        //     const vPath = `${path}${fileName}.${file_ext}`;
        //     const rPath = convertToAbsoluteUrl(vPath);
        //     // 1. directly call success callback
        //     if (successCallback) {
        //         successCallback({ virtualPath: vPath, absoluteUrl: rPath });
        //     }
        //
        //     // 2. build task object
        //     let formData = new FormData();
        //     formData.append("table", "UserHomeworkUnits");
        //     formData.append("field", "Files");
        //     formData.append("clientType", 1);
        //     formData.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
        //     formData.append("clientBuild", AppConfig.APP_CLIENT_BUILD);
        //     formData.append("timeZone", Helper.getTimeZone());
        //     formData.append("fileData", file);
        //     formData.append("fileName", fileName);
        //     formData.append("uploadPath", path);
        //
        //     const task = new UnitUploadFileTask({ userHomeworkId: ownerId, unitId, formData });
        //     // 2. add upload file task
        //     OfflineStorageHelper.appendTask(task);
        //
        //     DebugLogger.log("@offline@uploadFile is adding a task for unitId (" + unitId + ").");
        // }
    },

    recognizeFileImmediately(ownerId, ownerType, unitId, dialogIndex, sentenceIndex, unitType, file, unitData, successCallback, failureCallback) {
        DebugLogger.log("@offline@recognizeFileImmediately is called for unitId (" + unitId + "), dialogIndex (" + dialogIndex + "), sentenceIndex (" + sentenceIndex + ").");

        if (shouldUseOnlineService()) {
            SpeechRecognition.recognizeFile(file)
                .then(successCallback)
                .catch(failureCallback);

            DebugLogger.log("@offline@recognizeFileImmediately is executed for unitId (" + unitId + "), dialogIndex (" + dialogIndex + "), sentenceIndex (" + sentenceIndex + ").");
        } else {
            this.recognizeFile(ownerId, ownerType, unitId, dialogIndex, sentenceIndex, unitType, file, unitData, successCallback, failureCallback);
        }
    },

    recognizeFile(ownerId, ownerType, unitId, dialogIndex, sentenceIndex, unitType, file, unitData, successCallback, failureCallback) {
        DebugLogger.log("@offline@recognizeFile is called for unitId (" + unitId + "), dialogIndex (" + dialogIndex + "), sentenceIndex (" + sentenceIndex + ").");

        // if (!AppConfig.ENABLE_OFFLINE) {
            SpeechRecognition.recognizeFile(file)
                .then(successCallback)
                .catch(failureCallback);

            DebugLogger.log("@offline@recognizeFile is executed for unitId (" + unitId + "), dialogIndex (" + dialogIndex + "), sentenceIndex (" + sentenceIndex + ").");
        // } else {
        //     // 1. directly call success callback
        //     if (successCallback) {
        //         successCallback({ nodeArray: [], wordResultArray: [], accuracyScore: null, isOffline: true });
        //     }
        //
        //     // 2. build task object
        //     const task = new SpeechRecognizeTask({
        //         userHomeworkId: ownerId,
        //         unitId,
        //         dialogIndex,
        //         sentenceIndex,
        //         unitType,
        //         file,
        //         unitData,
        //     });
        //
        //     // 3. add update unit result task
        //     OfflineStorageHelper.appendTask(task);
        //
        //     DebugLogger.log("@offline@recognizeFile is adding a task for unitId (" + unitId + "), dialogIndex (" + dialogIndex + "), sentenceIndex (" + sentenceIndex + ").");
        // }
    },

    updateUnitResultImmediately(ownerId, ownerType, unitId, unitResult, successCallback, failureCallback) {
        DebugLogger.log("@offline@updateUnitResultImmediately is called for unitId (" + unitId + ").");

        if (shouldUseOnlineService()) {
            ApiService.post("/mobile/homework/unit/updateunitresult", { userHomeworkId: ownerId, userHomeworkUnitId: unitId, unitResult }, successCallback, failureCallback);

            DebugLogger.log("@offline@updateUnitResultImmediately is executed for unitId (" + unitId + ").");
        } else {
            this.updateUnitResult(ownerId, ownerType, unitId, unitResult, successCallback, failureCallback);
        }
    },

    updateUnitResult(ownerId, ownerType, unitId, unitResult, successCallback, failureCallback) {
        DebugLogger.log("@offline@updateUnitResult is called for unitId (" + unitId + ").");

        // if (!AppConfig.ENABLE_OFFLINE) {
            ApiService.post("/mobile/homework/unit/updateunitresult", { userHomeworkId: ownerId, userHomeworkUnitId: unitId, unitResult }, successCallback, failureCallback);

            DebugLogger.log("@offline@updateUnitResult is executed for unitId (" + unitId + ").");
        // } else {
        //     // 1. directly call success callback
        //     if (successCallback) {
        //         delayCallback(() => successCallback({ userHomeworkId: ownerId, userHomeworkUnitId: unitId, ...unitResult }));
        //     }
        //
        //     const task = new UpdateUnitResultApiCallTask({
        //         userHomeworkId: ownerId,
        //         unitId,
        //         unitResult,
        //         isReady: OfflineStorageHelper.isUpdateUnitResultTaskReadyWhenCreate(ownerId, unitId),
        //     });
        //     // 3. add update unit result task
        //     OfflineStorageHelper.appendTask(task);
        //
        //     DebugLogger.log("@offline@updateUnitResult is adding a task for unitId (" + unitId + ").");
        // }
    },

    updateUnitDraft(ownerId, ownerType, unitId, unitResult, successCallback, failureCallback) {
        DebugLogger.log("@offline@updateUnitDraft is called for unitId (" + unitId + ").");

        ApiService.post("/mobile/homework/unit/updateunitdraft", { userHomeworkId: ownerId, userHomeworkUnitId: unitId, unitResult }, successCallback, failureCallback);

        DebugLogger.log("@offline@updateUnitDraft is executed for unitId (" + unitId + ").");
    },

    completeHomeworkImmediately(ownerId, ownerType, successCallback, failureCallback) {
        DebugLogger.log("@offline@completeHomeworkImmediately is called for userHomeworkId (" + ownerId + ").");

        if (shouldUseOnlineService()) {
            ApiService.post("/mobile/homework/unit/completehomework", { userHomeworkId: ownerId }, successCallback, failureCallback);

            DebugLogger.log("@offline@completeHomeworkImmediately is executed for userHomeworkId (" + ownerId + ").");
        } else {
            this.completeHomework(ownerId, ownerType, successCallback, failureCallback);
        }
    },

    completeHomework(ownerId, ownerType, successCallback, failureCallback) {
        DebugLogger.log("@offline@completeHomework is called for userHomeworkId (" + ownerId + ").");

        // if (!AppConfig.ENABLE_OFFLINE) {
            ApiService.post("/mobile/homework/unit/completehomework", { userHomeworkId: ownerId }, successCallback, failureCallback);

            DebugLogger.log("@offline@completeHomework is executed for userHomeworkId (" + ownerId + ").");
        // } else {
        //     // 1. directly call success callback
        //     if (successCallback) {
        //         delayCallback(() => successCallback({ userHomeworkId: ownerId, isOffline: true }));
        //     }
        //
        //     const task = new CompleteHomeworkTask({ userHomeworkId: ownerId });
        //     // 3. add update unit result task
        //     OfflineStorageHelper.appendTask(task);
        //
        //     DebugLogger.log("@offline@completeHomework is adding a task for userHomeworkId (" + ownerId + ").");
        // }
    },

    getRecordConfig(successCallback, failureCallback) {
        DebugLogger.log("@offline@getRecordConfig is called.");

        if (shouldUseOnlineService()) {
            ApiService.post("/mobile/me/usersetting/getrecordconfig", {}, successCallback, failureCallback);

            DebugLogger.log("@offline@getRecordConfig is executed.");
        } else {
            // this.getOfflineRecordSetting(successCallback, failureCallback);
        }
    },

    setRecordConfig(setting, successCallback, failureCallback) {
        DebugLogger.log("@offline@setRecordConfig is called.");

        if (shouldUseOnlineService()) {
            ApiService.post("/mobile/me/usersetting/setrecordconfig", setting, successCallback, failureCallback);

            DebugLogger.log("@offline@setRecordConfig is executed.");
        } else {
            // this.setOfflineRecordConfig(setting, successCallback, failureCallback);
        }
    },

    // setOfflineRecordConfig: (params, successCallback, failureCallback) => {
    //     // 1. directly call success callback
    //     if (successCallback) {
    //         successCallback(params);
    //     }
    //
    //     //ApiService.post("/mobile/me/usersetting/setrecordconfig", params, successCallback, failureCallback);
    //     // 2. build task object
    //     //build a basic task in another queue
    //     const task = new BaseApiCallTask({
    //         ownerId: "General",
    //         taskQueueType: Constants.BACKGROUND_TASK_QUEUE_TYPE.UPLOAD,
    //         taskType: Constants.BACKGROUND_TASK_TYPE.API_CALL,
    //         apiMethod: "post",
    //         apiUrl: "/mobile/me/usersetting/setrecordconfig",
    //         jsonData: params,
    //         data: params,
    //         ownerType: 0,
    //     });
    //
    //     // 3. add update unit result task
    //     OfflineStorageHelper.appendTask(task);
    // },
    //
    // getOfflineRecordSetting: (successCallback, failureCallback) => {
    //     const setting = OfflineStorageHelper.getRecordSetting();
    //
    //     // 1. directly call success callback
    //     if (successCallback) {
    //         //这里返回太快,在离线模式下第一次在单元里访问record setting页面会使action handler不会触发
    //         //添加settimeout延迟来避免此问题
    //         delayCallback(() => successCallback(setting));
    //     }
    //
    //     if (!setting && failureCallback) {
    //         failureCallback({ code: -1, message: "NO Offline Data" });
    //     }
    // },

    startHomework(ownerId, ownerType, successCallback, failureCallback) {
        DebugLogger.log("@offline@startHomework is called for userHomeworkId (" + ownerId + ").");

        if (shouldUseOnlineService()) {
            ApiService.post("/mobile/homework/unit/starthomework", { userHomeworkId: ownerId }, successCallback, failureCallback);

            DebugLogger.log("@offline@startHomework is executed for userHomeworkId (" + ownerId + ").");
        } else {
            this.startHomeworkOffline(ownerId, ownerType, successCallback, failureCallback);
        }
    },

    // startHomeworkOffline(ownerId, ownerType, successCallback, failureCallback) {
    //     DebugLogger.log("@offline@startHomeworkOffline is called for userHomeworkId (" + ownerId + ").");
    //
    //     if (!AppConfig.ENABLE_OFFLINE) {
    //         ApiService.post("/mobile/homework/unit/starthomework", { userHomeworkId: ownerId }, successCallback, failureCallback);
    //
    //         DebugLogger.log("@offline@startHomeworkOffline is executed for userHomeworkId (" + ownerId + ").");
    //     } else {
    //         // 1. directly call success callback
    //         if (successCallback) {
    //             successCallback({ userHomeworkId: ownerId, isOffline: true });
    //         }
    //
    //         const task = new StartHomeworkTask({ userHomeworkId: ownerId });
    //         // 3. add update unit result task
    //         OfflineStorageHelper.appendTask(task);
    //
    //         DebugLogger.log("@offline@startHomeworkOffline is adding a task for userHomeworkId (" + ownerId + ").");
    //     }
    // },

    restart(ownerId, ownerType, unitId, successCallback, failureCallback) {
        DebugLogger.log("@offline@restart is called for userHomeworkId (" + ownerId + ") uintId (" + unitId + ").");

        if (shouldUseOnlineService()) {
            ApiService.post("/mobile/homework/unit/restart", { userHomeworkUnitId: unitId }, successCallback, failureCallback);

            DebugLogger.log("@offline@restart is executed for userHomeworkId (" + ownerId + ") uintId (" + unitId + ").");
        } else {
            this.restartOffline(ownerId, ownerType, unitId, successCallback, failureCallback);
        }
    },

    // restartOffline(ownerId, ownerType, unitId, successCallback, failureCallback) {
    //     DebugLogger.log("@offline@restartOffline is called for userHomeworkId (" + ownerId + ") uintId (" + unitId + ").");
    //
    //     if (!AppConfig.ENABLE_OFFLINE) {
    //         ApiService.post("/mobile/homework/unit/restart", { userHomeworkUnitId: unitId }, successCallback, failureCallback);
    //
    //         DebugLogger.log("@offline@restartOffline is executed for userHomeworkId (" + ownerId + ") uintId (" + unitId + ").");
    //     } else {
    //         // 1. directly call success callback
    //         if (successCallback) {
    //             successCallback({ userHomeworkId: ownerId, userHomeworkUnitId: unitId, isOffline: true });
    //         }
    //
    //         const task = new RestartUnitTask({ userHomeworkId: ownerId, unitId });
    //         // 3. add update unit result task
    //         OfflineStorageHelper.appendTask(task);
    //
    //         DebugLogger.log("@offline@startHomeworkOffline is adding a task for userHomeworkId (" + ownerId + ") uintId (" + unitId + ").");
    //     }
    // },
};

export default UnitService;
export { shouldUseOnlineService };
